"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appRouter = void 0;

/**
 * @file app原生路由
 * @author qiaogang
 * @date 2020-02-13
 */
var appRouter = {
  // 书房，老版本params_tab=1，新版本tab_name=book，无需兼容
  book: 'igetcool://juvenile.dedao.app/go/main?params_tab=1&tab_name=book',
  // 首页，老版本params_tab=0，新版本tab_name=discover，无需兼容
  home: 'igetcool://juvenile.dedao.app/go/main?params_tab=0&tab_name=discover'
};
exports.appRouter = appRouter;